import { apiRequest } from "./api";


interface SendMessagePayload {
  RecipientType: 'BRANCH' | 'PAYROLL';
  MessageContent: string;
}

export const sendMessage = (payload: SendMessagePayload) => {
  return apiRequest<void>({
    method: 'POST',
    url: '/messaging',
    data: payload,
  });
};
